import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchAllDepartments(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('cms/admin/blogcategories',{ params: queryParams } )
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

     
    createDepartment(ctx, userData) {
      return new Promise((resolve, reject) => {
        axios
          .post('cms/admin/blogcategory',  userData  )
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
      
    updateblogcategory(ctx, userData) {
      return new Promise((resolve, reject) => {
        axios
          .put('cms/admin/updateblogcategory',  userData  )
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },


  },
}
